import { mode } from '@chakra-ui/theme-tools';

export const inputStyles = {
  components: {
    Input: {
      variants: {
        main: (props: any) => ({
          field: {
            bg: mode('transparent', 'navy.800')(props),
            border: '1px solid',
            borderColor: mode('gray.300', 'whiteAlpha.100')(props),
            fontSize: 'sm',
            p: '19px',
            borderRadius: '16px',
            _placeholder: {
              fontWeight: '400',
              color: 'secondaryGray.600',
            },
            h: '40px',
            maxH: '40px',
            _disabled: {
              backgroundColor: mode('gray.200', 'navy.700')(props),
            },
            fontWeight: 500,
            color: mode('secondaryGray.900', 'white')(props),
            _hover: {
              borderColor: mode('secondaryGray.900', 'white')(props),
            },
            _focus: {
              borderColor: mode('secondaryGray.900', 'white')(props),
            },
            _invalid: {
              borderColor: mode('red.600', 'red.600')(props),
              boxShadow: 'none',
            },
          },
        }),
        auth: (props: any) => ({
          field: {
            fontWeight: '500',
            color: mode('navy.700', 'white')(props),
            bg: mode('transparent', 'transparent')(props),
            border: '1px solid',
            borderColor: mode(
              'secondaryGray.100',
              'rgba(135, 140, 189, 0.3)',
            )(props),
            borderRadius: '16px',
            _placeholder: { color: 'secondaryGray.600', fontWeight: '400' },
          },
        }),
        search: () => ({
          field: {
            border: 'none',
            py: '11px',
            borderRadius: 'inherit',
            _placeholder: { color: 'secondaryGray.600' },
          },
        }),
      },
    },

    NumberInput: {
      baseStyle: {
        field: {
          fontWeight: 400,
        },
      },

      variants: {
        main: (props: any) => ({
          field: {
            bg: 'transparent',
            border: '1px solid',
            borderColor: 'secondaryGray.100',
            borderRadius: '16px',
            _placeholder: { color: 'secondaryGray.600' },
            _invalid: {
              borderColor: mode('red.600', 'red.600')(props),
              boxShadow: 'none',
            },
          },
        }),
        search: () => ({
          field: {
            border: 'none',
            py: '11px',
            borderRadius: 'inherit',
            _placeholder: { color: 'secondaryGray.600' },
          },
        }),
      },
    },

    Select: {
      variants: {
        main: (props: any) => ({
          field: {
            bg: mode('transparent', 'navy.800')(props),
            border: '1px solid',
            color: mode('secondaryGray.900', 'white')(props),
            borderColor: mode('gray.300', 'whiteAlpha.100')(props),
            borderRadius: '16px',
            _placeholder: { color: 'secondaryGray.600' },
            h: '40px',
            maxH: '40px',
            cursor: 'pointer',
            _hover: {
              borderColor: mode('secondaryGray.900', 'white')(props),
            },
            _focus: {
              borderColor: mode('secondaryGray.900', 'white')(props),
            },
            _disabled: {
              borderColor: mode('gray.300', 'whiteAlpha.100')(props),
              backgroundColor: mode('gray.200', 'navy.700')(props),
            },
            _invalid: {
              borderColor: mode('red.600', 'red.600')(props),
              boxShadow: 'none',
            },
          },
          icon: {
            color: 'secondaryGray.600',
          },
        }),
        search: (props: any) => ({
          field: {
            border: 'none',
            py: '11px',
            borderRadius: 'inherit',
            _placeholder: { color: 'secondaryGray.600' },
          },
        }),
      },
    },
  },
};
